import {Observable, of, Subject, Subscription} from 'rxjs';
import {catchError, concatMap} from 'rxjs/operators';

/**
 * Executes enqueued observables one at a time, in enqueue order.
 *
 * The person profile endpoints (details, sensitive, address, photo) all
 * rewrite the same backend entity, so requests running in parallel can
 * overwrite each other's changes (lost update). Queueing the save requests
 * keeps at most one of them in flight at a time.
 *
 * A failed task does not stop the queue - remaining tasks still run.
 */
export class SerializedTaskQueue {
  private tasks = new Subject<Observable<unknown>>();
  private subscription: Subscription = this.tasks.pipe(
    concatMap(task => task.pipe(catchError(() => of(null))))
  ).subscribe();

  enqueue(task: Observable<unknown>) {
    this.tasks.next(task);
  }

  dispose() {
    this.subscription.unsubscribe();
  }
}
